module.exports = __webpack_public_path__ + "img/amex.93faa4e9.svg";